import React, { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { Button } from 'antd';

type AntButtonProps = ComponentProps<typeof Button>;

type NavigationButtonsProps = {
  prevProps: AntButtonProps;
  nextProps: Omit<AntButtonProps, 'disabled'>;
};

const StyledNavigation = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 82px;
`;

const NavigationButtons = ({ prevProps, nextProps }: NavigationButtonsProps) => (
  <StyledNavigation>
    <Button
      {...({
        children: <>&lt; Back</>,
        size: 'large',
        type: 'default',
        ...prevProps
      } as AntButtonProps)}
      data-testid="back-button"
    />
    <Button
      {...({
        children: <>Next &gt;</>,
        size: 'large',
        type: 'primary',
        ...nextProps
      } as AntButtonProps)}
      data-testid="next-button"
    />
  </StyledNavigation>
);

export default NavigationButtons;
